import * as React from 'react';
import cx from 'classnames';
import { Box } from '../../utils/components/Box.js';
let getSizeValue = (size) => {
  switch (size) {
    case 'small':
      return 's';
    case 'medium':
      return 'm';
    case 'large':
      return 'l';
    default:
      return size;
  }
};
export const Icon = React.forwardRef((props, ref) => {
  let {
    size = 'medium',
    fill = 'default',
    className,
    padded = false,
    ...rest
  } = props;
  return React.createElement(Box, {
    as: 'span',
    className: cx('iui-svg-icon', className),
    'data-iui-icon-size': getSizeValue(size),
    'data-iui-icon-color': fill,
    'data-iui-padded': padded ? 'true' : void 0,
    ref: ref,
    ...rest,
  });
});
Icon.displayName = 'Icon';
